import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import MenuIcon from "@mui/icons-material/Menu";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import Collapse from "@mui/material/Collapse";
import LinkIcon from "@mui/icons-material/Link";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
export default function TheDrawer({ theMode, getMode, open }) {
	const [state, setState] = React.useState({
		top: false,
		left: false,
		bottom: false,
		right: false
	});
	React.useEffect(() => {
		toggleDrawer("right", open)({ type: "click" });
	}, [open]);
	const [links1Open, setLinks1Open] = React.useState(true);
	const toggleDrawer = (anchor, open) => (event) => {
		console.log("toggleDrawer");
		console.log(event.type);
		console.log(anchor);
		console.log(open);
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setState({ ...state, [anchor]: open });
	};
	const handleChange = (mode) => () => {
		// console.log("Mode Changed: " + mode);
		const queryString = `?mode=${mode}`;
		getMode(mode);
		window.history.pushState({}, "", queryString);
	};
	const handleClick = () => {
		setLinks1Open(!links1Open);
	};
	const list = (anchor) => (
		<Box
			sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
			role="presentation"
			onClick={toggleDrawer(anchor, false)}
			onKeyDown={toggleDrawer(anchor, false)}
		>
			<List>
				<List>
					<ListItem key="Ad Testing" disablePadding>
						<ListItemButton
							onClick={handleChange("adtesting")}
							selected={theMode === "adtesting"}
						>
							<ListItemIcon>
								<AdsClickIcon />
							</ListItemIcon>
							<ListItemText primary="Ad Testing" />
						</ListItemButton>
					</ListItem>
					<Divider />
					<ListItem key="Flipp" disablePadding>
						<ListItemButton
							onClick={handleChange("flipp")}
							selected={theMode === "flipp"}
						>
							<ListItemIcon>
								<AdsClickIcon />
							</ListItemIcon>
							<ListItemText primary="Flipp Ads" />
						</ListItemButton>
					</ListItem>
					<Divider />
					<ListItem key="Facebook Catalog Ads" disablePadding>
						<ListItemButton
							onClick={handleChange("fbcatads")}
							selected={theMode === "fbcatads"}
						>
							<ListItemIcon>
								<AdsClickIcon />
							</ListItemIcon>
							<ListItemText primary="Facebook Catalog Ads" />
						</ListItemButton>
					</ListItem>
					<Divider />
					<ListItem key="Facebook Marketing Ads" disablePadding>
						<ListItemButton
							onClick={handleChange("fbmarkads")}
							selected={theMode === "fbmarkads"}
						>
							<ListItemIcon>
								<AdsClickIcon />
							</ListItemIcon>
							<ListItemText primary="Facebook Marketing Ads" />
						</ListItemButton>
					</ListItem>
				</List>
			</List>
			<Divider />
			<ListItem key="Vast Testing" disablePadding>
				<ListItemButton
					onClick={handleChange("vastvideo")}
					selected={theMode === "vastvideo"}
				>
					<ListItemIcon>
						<AdsClickIcon />
					</ListItemIcon>
					<ListItemText primary="Vast Testing" />
				</ListItemButton>
			</ListItem>
			<ListItem key="PHX Vast Campaigns" disablePadding>
				<ListItemButton
					onClick={handleChange("phxvastcampaigns")}
					selected={theMode === "phxvastcampaigns"}
				>
					<ListItemIcon>
						<AdsClickIcon />
					</ListItemIcon>
					<ListItemText primary="PHX Vast Campaigns" />
				</ListItemButton>
			</ListItem>
			<Divider />
			<List>
				<List>
					<ListItem key="Image Service Testing" disablePadding>
						<ListItemButton
							onClick={handleChange("imageservicetesting")}
							selected={theMode === "imageservicetesting"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="Image Service Testing" />
						</ListItemButton>
					</ListItem>
				</List>
			</List>
			<Divider />
			<List>
				<List>
					<ListItem key="Series API" disablePadding>
						<ListItemButton
							onClick={handleChange("seriesapi")}
							selected={theMode === "seriesapi"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="Series API" />
						</ListItemButton>
					</ListItem>
				</List>
			</List>
			<Divider />
			<List>
				<List>
					<ListItem key="Dashboards" disablePadding>
						<ListItemButton
							onClick={handleChange("dashboards")}
							selected={theMode === "dashboards"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="Dashboards" />
						</ListItemButton>
					</ListItem>
					<ListItem key="Benchmark and Leads Processing" disablePadding>
						<ListItemButton
							onClick={handleChange("benchmarkandleadsprocessing")}
							selected={theMode === "benchmarkandleadsprocessing"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="Benchmark and Leads Processing" />
						</ListItemButton>
					</ListItem>
					<ListItem key="Toyota Sales Uploader" disablePadding>
						<ListItemButton
							onClick={handleChange("toyotasalesuploader")}
							selected={theMode === "toyotasalesuploader"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="Toyota Sales Uploader" />
						</ListItemButton>
					</ListItem>
				</List>
			</List>
			<Divider />

			<List>
				<List>
					<ListItem key="Natural Language Query" disablePadding>
						<ListItemButton
							onClick={handleChange("nlquery")}
							selected={theMode === "nlquery"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="Natural Language Query" />
						</ListItemButton>
					</ListItem>
				</List>
			</List>
			<List>
				<List>
					<ListItem key="OAT Evaluation System" disablePadding>
						<ListItemButton
							onClick={handleChange("OATEval")}
							selected={theMode === "OATEval"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="OAT Evaluation System" />
						</ListItemButton>
					</ListItem>
				</List>
			</List>
			<Divider />
			<List>
				<List>
					<ListItem key="Innovid Segments" disablePadding>
						<ListItemButton
							onClick={handleChange("innovidsegments")}
							selected={theMode === "innovidsegments"}
						>
							<ListItemIcon>
								<DirectionsCarIcon />
							</ListItemIcon>
							<ListItemText primary="Innovid Segments" />
						</ListItemButton>
					</ListItem>
				</List>
			</List>
			<Divider />

			<ListItemButton onClick={handleClick}>
				<ListItemIcon>
					<FormatListBulletedIcon />
				</ListItemIcon>
				<ListItemText primary="Links" />
				{links1Open ? <ExpandLess /> : <ExpandMore />}
			</ListItemButton>
			<Collapse in={links1Open} timeout="auto" unmountOnExit>
				<List component="div" disablePadding>
					<ListItemButton
						sx={{ pl: 4 }}
						onClick={() =>
							window.open(
								"https://www.tcaadev.com/oatreporting/report-reader.html",
								"_blank"
							)
						}
					>
						<ListItemIcon>
							<LinkIcon />
						</ListItemIcon>
						<ListItemText primary="OAT Reporting Table" />
					</ListItemButton>
				</List>
			</Collapse>
		</Box>
	);

	return (
		<div>
			{["right"].map((anchor) => (
				<React.Fragment key={anchor}>
					<Button id="drawerButton" onClick={toggleDrawer(anchor, true)}>
						<MenuIcon />
					</Button>
					<Drawer
						anchor={anchor}
						open={state[anchor]}
						onClose={toggleDrawer(anchor, false)}
					>
						{list(anchor)}
					</Drawer>
				</React.Fragment>
			))}
		</div>
	);
}
